module.exports = __webpack_public_path__ + "img/slogan2.8b606b73.png";